import './index.scss'
import {
  RadioButton,
  FormGroup,
  RadioButtonGroup
} from 'carbon-components-react'
RadioButton.Form = FormGroup
RadioButton.ButtonGroup = RadioButtonGroup

export { RadioButton, FormGroup, RadioButtonGroup, RadioButton as default }
